<template>
    <v-container fluid fill-height px-0 class="main-container d-block">
        <div class="content-block">
            <HeaderMenu title="История отопителя" class="mx-6 mb-6" back-page/>
            <v-layout row v-if="deviceData" class="bold-text mx-6 mb-3 w-100 justify-center">
                {{ deviceData.name }}
                <span class="subtitle-text ml-1" v-if="deviceData.location">
                    ({{ deviceData.location }})
                </span>
            </v-layout>
            <v-layout column ma-0 class="main-text mb-5 w-100 heatings-list scrollbar-block" v-if="heatingHistory.length > 0">
                <v-flex
                    xs12
                    v-for="(heating, index) in heatingHistory"
                    :key="index" class="heatings"
                    :class="{'heatings__high': heating.new_day}"
                >
                    <v-layout v-if="heating.new_day" class="heatings__title bold-text">
                        {{heating.new_day}}
                    </v-layout>
                    <v-flex class="heating-row">
                        <div class="heating-row__time">
                            <div class="d-inline-flex" v-if="heating.state.heating">
                                <v-img max-height="30px" max-width="30px" :src="require('@/assets/icons/flame_icon.svg')" class="d-inline-flex"/>
                            </div>
                            <div class="d-inline-flex" v-else>
                                <v-img max-height="30px" max-width="30px" :src="require('@/assets/icons/flame_disabled_icon.svg')" class="d-inline-flex"/>
                            </div>
                            <div class="time-row bold-text d-inline-flex">
                                время: <span class="main-text">{{heating.start_updated}}</span>
                            </div>
                        </div>
                    </v-flex>
                </v-flex>
            </v-layout>
            <div class="d-flex align-center heatings-list__error" v-else>
                <v-flex class="d-block text-center">
                    <div>
                        <v-img :src="require('@/assets/images/error.svg')" class="d-inline-flex mb-8"/>
                        <div class="common-text text-center">
                            Нет истории
                        </div>
                    </div>
                </v-flex>
            </div>
            <ModalWaiting ref="modalWaiting" title="Загрузка событий" noCancel></ModalWaiting>
        </div>
    </v-container>
</template>

<script>
import HeaderMenu from "@/components/core/HeaderMenu";
import ModalWaiting from "@/components/modals/ModalWaiting";
import {eventBus} from "@/main";
import {getTimeFromDate} from "@/utils";
import {timeWithTZ} from "@/utils";

export default {
    name: "HeatingHistory",
    components: {
        HeaderMenu,
        ModalWaiting,
    },
    data() {
        return {
            deviceUID: null,
            deviceData: {},
            heatingHistory: [],
        };
    },
    created() {
        eventBus.$on("reconnect", this.loadPage);
    },
    beforeDestroy() {
        eventBus.$off("reconnect", this.loadPage);
    },
    mounted() {
        this.loadPage();
    },
    methods: {
        loadPage() {
            this.deviceUID = this.$route.params.id;
            if (this.deviceUID) {
                this.getHeatings();
            }
        },
        getHeatings() {
            this.heatingHistory = [];
            this.$refs.modalWaiting.open();
            this.$http.get('/devices/guest/heating-history/' + this.deviceUID + '/')
                .then((res) => {
                    this.deviceData = res.data.device;
                    this.heatingHistory = res.data.actions;
                    this.heatingHistory.forEach((heating, index) => {
                        heating.start_updated = this.getTime(heating.date);
                        if (index > 0) {
                            if (this.checkDay(heating.date) != this.checkDay(this.heatingHistory[index - 1].date)) {
                                heating.new_day = this.checkDay(heating.date);
                                heating.new_day = this.reverseDate(heating.new_day);
                            }
                        } else {
                            heating.new_day = this.checkDay(heating.date);
                            heating.new_day = this.reverseDate(heating.new_day);
                        }
                    });
                })
                .finally(() => {
                    this.$refs.modalWaiting.close();
                });
        },
        getTime(time) {
            return getTimeFromDate(time);
        },
        checkDay(day) {
            return timeWithTZ(day).split('T')[0];
        },
        reverseDate(time) {
            const [year, month, day] = time.split("-");
            return day + "." + month + "." + year;
        },
        formattedDuration(val) {
            val = parseInt(val);
            if (val >= 60) {
                let minutes = Math.floor(val / 60);
                let seconds = val % 60;
                let hours = Math.floor(minutes / 60);
                minutes = minutes % 60;
                let row = "";
                if (hours) {
                    row = hours + " ч.";
                }
                if (minutes) {
                    if (hours) {
                        row += " " + minutes + " мин.";
                    }
                    else {
                        row += minutes + " мин.";
                    }
                }
                if (seconds) {
                    if (hours || minutes) {
                        row += " " + seconds + " сек.";
                    } else {
                        row += seconds + " сек.";
                    }
                }
                return row;
            }
            return val + " сек.";
        },
    },
}
</script>

<style lang="scss" scoped>
.heatings-list {
    height: calc(100vh - 138px) !important;
    overflow-y: auto;
    padding: 0 24px;

    &::-webkit-scrollbar {
        display: none;
    }

    &__error {
        display: flex;
        height: calc(100% - 56px) !important;
    }

    .heatings {
        max-height: 44px;

        &__high {
            max-height: 95px;
        }

        &:not(:last-child) {
            border-bottom: 1px solid #787878;
        }

        &__title {
            margin: 10px 0;
            padding: 4px 0;
            background: #FFFFFF;
            color: #787878;
            justify-content: center;
            border-radius: 30px;
        }

        .heating-row {
            display: flex;
            flex-direction: row;
            align-items: center;
            width: 100%;
            min-height: 44px;
            padding: 4px 0;

            &:not(:last-child) {
                border-bottom: 1px solid #787878;
            }

            &__time {
                display: inline-flex;
                align-items: center;

                .time-row:not(:first-child) {
                    margin-left: 12px;
                }
            }

            .v-image {
                max-height: 36px;
                max-width: 36px;
            }
        }
    }
}

@media screen and ( max-width: 700px) {
    .heatings-list .heatings .heating-row__time {
        .time-row:not(:first-child) {
            margin-left: 0;
        }
    }
}
</style>